import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

function formatContactAddress(ci) {
    if (!ci) {
        return ''
    }

    const line = [
        ci.address_1,
        ci.city,
        [ci.state, ci.zip].filter(Boolean).join(' '),
    ].filter(Boolean).join(', ')

    return line.trim()
}

const LawFirmAddress = ({lawFirmData}) => {
    const [locationAddress, setLocationAddress] = useState(null)
    const activeCase = useSelector(state => state.case.activeCase)

    useEffect(() => {
        const attorneyFromCase = activeCase?.attorneys?.find(item => item.id == lawFirmData?.id)
        const locationCi =
            attorneyFromCase?.location?.contact_information ||
            lawFirmData?.location?.contact_information
        const firmCi = lawFirmData?.law_firm?.contact_information

        const address = formatContactAddress(locationCi) || formatContactAddress(firmCi) || null
        setLocationAddress(address)
    }, [activeCase, lawFirmData])

    return <>{locationAddress}</>
}

export default LawFirmAddress
